<template>  
  <div>    
  <b-modal
    id="view-perm-peep-modal"
    title="Permanent PEEPs View Modal"
    centered
    hide-footer
    size="xl"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">Permanent PEEPs</h2>
    </template>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="users"
      details-td-class="m-0 p-0"
      small
      v-if="hasPermission('read_user')"
      :per-page="0"
    >
      <template #cell(name)="row">
        {{ row.item.user_data.name ? row.item.user_data.name : "" }}
      </template> 
      <template #cell(email)="row">
        {{ row.item.user_data.email ? row.item.user_data.email : "" }}
      </template>
      <template #cell(building)="row">
        {{ row.item.flat_data.building ? row.item.flat_data.building : "" }}
      </template>
      <template #cell(floor)="row">
        {{ row.item.flat_data.floor ? row.item.flat_data.floor : "" }}
      </template>
      <template #cell(flat)="row">
        {{ row.item.flat_data.flat ? row.item.flat_data.flat : "" }}
      </template> 
    </b-table>
    <b-pagination
      size="md"
      :total-rows="totalItems"
      v-model="currentPage"
      :per-page="perPage"
    ></b-pagination>
  </b-modal>  
  </div>  
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  mixins: [util],
  data() {
    return {
      required,
      fields: [
        { key: "name", label: "Name" },
        { key: "email", label: "email" },
        { key: "building", label: "Building" },
        { key: "floor", label: "Floor" },
        { key: "flat", label: "Appartment" },
        { key: "nominee_name", label: "Nominee Name" },
        { key: "nominee_contact", label: "Nominee Contact" },
        { key: "assistance_type", label: "Assistance Type" },
        { key: "review_date", label: "Review Date" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      user: {},
      users: [],
    };
  },
  methods: {
    ...mapActions({
      getPeeps: "appData/getPeeps",
      updateUser: "appData/updateUser",
    }),
    async fetchPaginatedData() {
      try {
        const res = await this.getPeeps({
          pageNumber: this.currentPage,
          peep_type: 'Permanent',
        });
        this.users = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission"
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
  async mounted(){
    await this.fetchPaginatedData();
  }
};
</script>

<style></style>
